<script>
  export let value = 42;
  export let kpi = "define_kpi";
</script>

<div class="kpi_wrapper">
  <div class="kpi bold"><slot name="kpi">{kpi}</slot></div>
  <div class="value"><slot name="value">{value}</slot></div>
</div>

<style>
  .kpi_wrapper {
    background-color: var(--pax-smoke);
    height: 3rem;
    padding: 0.5rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    border-radius: 0.5rem;
  }

  .kpi,
  .value {
    min-width: 0;
  }

  .kpi {
    flex: 1;
    overflow: hidden;
  }

  .value {
    flex-shrink: 0;
    max-width: 60%;
    overflow: hidden;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
